import React, { useEffect, useState } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import BackdropScI from "../../services/BackdropScI";
import { premiA, sto } from "../../Context/InshData";
// import {uri, }  from '../../help/Api';
import { useLocation } from "react-router-dom";
// import {sto,insh} from '../../Context/InshData';
import axios from "axios";
import dataF from "../../Server/dataF.json";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
// import dataF from '../../Server/dataF.json';
import { Apis } from "../../help/Apis";
import MenusContainer from "../Menues/MenusContainer";
import MenusContRef from "../Menues/MenusContRef";
import Swipeable from "./Swipeable";
import { useStylesMain } from "../../St/Fronts/UseStyle";
import { getLS } from "../../utils/useLS";
import POSDashboardCon from "../../comps/Dashboard/POSDashboardCon";
import { GetItemFromOptions } from "../../services/global-services";
import { useHistory } from "react-router-dom";
import moment from "moment";

// import { Alert, AlertTitle } from "@material-ui/lab";
import { colors, Grid, Hidden, Snackbar } from "@material-ui/core";
import RePay from "../../Start/RePay";
import SubScriptionEndingAlert from "../../subscriptionAlert";

export function isExpiredAnull(startDate, endDate) {
  // const dateStart = (moment(startDate).format("YYYY-MM-DD"));
  if (startDate == null)
    return true;
  let sdate = moment(new Date());
  const daysTotal = sdate.diff(startDate, 'days');
  return daysTotal >= 370;

  // if (endDate == null) {
  //   if (startDate == null)
  //     return true;
  //   let sdate = moment(new Date());
  //   const daysTotal = sdate.diff(dateStart, 'days');
  //   return daysTotal >= 380;
  // } else {
  //   const dateEnd = (moment(endDate).format("YYYY-MM-DD"));
  //   let sdate = moment(new Date());
  //   const daysTotal = sdate.diff(dateEnd, 'days');
  //   return daysTotal > 15;
  // }
}
export default function Main(props) {
  const { isFromLgin } = props;
  const clas = useStylesMain();
  // const loc = useLocation();
  const [permiApp, setPermiApp] = useState({});
  const [showSc, setShowSc] = useState(true);
  const [Users, setUsers] = useState([]);
  const [userData, setUserData] = useState({ id: 0, name: "0" });
  const [found, setFound] = useState({});



  let pScr = getLS("premiScr", {});
  const [uris, setUris] = useState({ uri: "http://localhost:8184/" });
  const [salePointOnly, setSalePointOnly] = useState(
    pScr?.salePointOnly ?? false
  );


  const getUPrmi = async (urisp, stos) => {
    setUserData({ id: stos.idi, name: stos.usernames });
    const tb = {
      wait: true,
      // PermissionsScreen1: true,
      // PermissionsPointsOfsales: true,
      UsersA: true,
      GetFoundation: true,
      parms: {
        iuserid: stos.idi,
        ibranchid: stos.branchi,
        iempid: stos.empi,
        branch: stos.branchi,
        iFoundid: 1,
        tname:"FromMain"
      },

    };

    await axios
      .post(urisp + `Res`, tb)
      .then((res) => {
        console.log("__res__");
        // console.log(res.data?.permisScr);
        console.log("__res__");
        // window.localStorage.setItem(
        //   "premiScr",
        //   JSON.stringify(res.data?.permisScr)
        // );
        // setSalePointOnly(res.data.permisScr?.salePointOnly);
        let loc = getLS("premiApp", {});
        setUsers(res?.data?.Users);
        setFound(res?.data?.Found);
        console.log(" the  __users__ is", res?.data?.Users);
        console.log(" def  __users__ is", stos);
        console.log("loc");
        console.log(loc);
        console.log("Maiiiiiiin");
        // alert('stop')
        setPermiApp(loc);
        setShowSc(res.data.wait.state);
        console.log("__res__");
      })
      .catch((error) => { });
  };

  useEffect(() => {
    console.log("premia", premiA);
    const urisR = Apis();
    let loc = getLS("DataRem", {});
    setUris(urisR);
    getUPrmi(urisR, loc);
  }, []);

  //----------------------------------------------------------------
  const locConn = JSON.parse(localStorage.getItem("infoConn")) || {};

  const inshState = {
    server: locConn.server,
    ipinsh: locConn.ipinsh,
    changip: locConn.changip,
    ip: locConn.ip,
    endDigtip: locConn.endDigtip,
    namedb: locConn.namedb,
    id: locConn.id,
    pass: locConn.pass,
    useUri: locConn.useUri,
    port: locConn.port,
    ftp: locConn.ftp,
    typeConnct: locConn.typeConnct,
    mode: locConn.mode,
    leavle: "signIn",
  };

  const refDatas_out = () => {
    localStorage.removeItem("dataShamel");
    let loc = JSON.parse(localStorage.getItem("premiApp"));

    localStorage.setItem("premiApp", JSON.stringify({ ...loc, id: 0 }));
    localStorage.removeItem("DataRem");
  };
  let his = useHistory();

  function refreshPage() {
    his.push({ pathname: "/" });
    window.location.reload(false);
  }

  const singout = () => {
    refDatas_out();
    console.log("swipeable infoconn")
    localStorage.setItem("infoConn", JSON.stringify(inshState));
    refreshPage();
  };
  const DefUsers = Users ? Users : [];
  const valueUsers = GetItemFromOptions(userData?.id, DefUsers);

  useEffect(() => {
    if (valueUsers?.name == null || valueUsers?.name == "") return;
    if (userData?.name != valueUsers?.name) {
      singout();
    };
  }, [Users, userData]);

  const [snack, setSnack] = useState({});
  // useEffect(() => {
  //   let sdate = moment(new Date());
  //   const daysTotal = sdate.diff(found.StartWorkDate, 'days');
  //   console.log("the daysssss total is", daysTotal);
  //   if (daysTotal < 365 && daysTotal >= 335) {
  //   }

  // }, [found, snack]);

  //--------------------------------------------------------------------
  return showSc ? (
    <BackdropScI />
  ) : (
    <React.Fragment>
      <Hidden smDown={["sm"]}>
        <Grid container item xs={12} spacing={3}
          style={{
            backgroundColor: colors.grey[100],
            textAlign: "right", direction: "rtl",
            fontSize: 18,
            width: "100%",
            fontWeight: "bold",
            padding: 10,
            color:colors.blue[900]
          }}>
          <Grid item >
            {found?.nameA}
          </Grid>
          <Grid item >
            {"الفرع"} {"   :"} {sto?.branchNames}
          </Grid>
          <Grid item  >
            {"المستخدم"} {"   :"} {sto?.usernames}
          </Grid>
        </Grid>
      </Hidden>

      <CssBaseline />
      <SubScriptionEndingAlert startDate={found?.StartWorkDate?? null} endDate={found?.EndWorkDate?? null}/>     

      {isExpiredAnull(found?.StartWorkDate ?? null, found?.EndWorkDate ?? null) ?
        (
          <RePay singout={singout} />
        ) : premiA.menuMin != undefined && premiA.id != 0 ? (
          <React.Fragment>
            {salePointOnly ? (
              <POSDashboardCon found={found}/>
            ) : (
              <>
                <Container maxWidth="lg">
                  <Typography component="div" className={clas.root}>
                    <MenusContainer />

                    {/* <MenusContRef/> */}
                  </Typography>
                </Container>

                <Typography
                  component="div"
                  style={{
                    marginTop: "2vh",
                    backgroundColor: "#f6f7f9",
                  /*height: '96vh',*/ fontFamily: "Tajawal",
                  }}
                >
                  {/* {riv && <Dtatistics/>} */}
                  <Swipeable found={found} />
                </Typography>
              </>
            )}
          </React.Fragment>
        ) : (
          <Container
            maxWidth="lg"
            style={{
              backgroundColor: "#fff",
              height: "100vh",
              paddingTop: "30vh",
            }}
          >
            <MenusContRef />

          </Container>
        )}
    </React.Fragment>
  );
}
